module.exports = __webpack_public_path__ + "img/2@3x.eeef5322.png";